/* ¿Dónde va el logo? · Imprimirlo
 *
 * El cliente no coloca: elige. Se le enseña la prenda con el logo ya puesto en
 * cada sitio posible y toca el que quiere. Es escoger, no diseñar.
 *
 * Las prendas están dibujadas aquí con trazos, no con fotos: así valen para
 * cualquier color, no hay que preparar imágenes por producto y pesa nada.
 *
 * Las medidas son de verdad: cada posición dice a cuántos cm va a salir el
 * logo, y el dibujo lo enseña a esa escala sobre la prenda.
 */
(function () {
  'use strict';

  /* Silueta con las medidas del datasheet del proveedor (JHK TS150ST, la
   * camiseta que se vende): talla M, ancho 51 cm y largo 70 cm.
   *
   * Escala: el torso va de x=62 a x=138, o sea 76 unidades para 51 cm, que son
   * 1,49 u/cm. El largo, 70 cm, lleva de y=24 a y=129.
   *
   * Las mangas van estrechas a propósito. Dibujadas anchas —112 unidades de
   * punta a punta— la camiseta parecía de niño aunque el largo fuera el de
   * tabla: lo que se lee como prenda de adulto es la proporción entre cuerpo y
   * manga, no el largo. Aquí son 102 unidades, 68 cm en plano, que es lo que
   * mide de verdad una M.
   */
  var CUERPO = 'M113,24 C122,25 128,27 134,31 L151,47 C153,50 153,53 151,56 L144,66 ' +
    'L138,58 L138,124 C138,127 136,129 133,129 L67,129 C64,129 62,127 62,124 ' +
    'L62,58 L56,66 L49,56 C47,53 47,50 49,47 L66,31 C72,27 78,25 87,24 ' +
    'C90,31 110,31 113,24 Z';

  /* Manga larga. Mismo cuerpo y mismo cuello que la camiseta: lo que cambia es
     que la manga baja hasta el puño en vez de acabar en el bíceps. Las mangas
     caen ligeramente abiertas, que es como cuelga una prenda en plano. */
  var LARGA = 'M113,24 C122,25 128,27 134,31 L152,62 L150,101 L141,101 L138,58 ' +
    'L138,124 C138,127 136,129 133,129 L67,129 C64,129 62,127 62,124 ' +
    'L62,58 L59,101 L50,101 L48,62 L66,31 C72,27 78,25 87,24 ' +
    'C90,31 110,31 113,24 Z';

  /* El mismo cuerpo con el escote en pico. El cuello va en el CONTORNO, no en
     las líneas de adorno: dibujar una V encima del cuello redondo deja una
     camiseta de cuello redondo con una V pintada dentro. */
  var PICO = 'M113,24 C122,25 128,27 134,31 L151,47 C153,50 153,53 151,56 L144,66 ' +
    'L138,58 L138,124 C138,127 136,129 133,129 L67,129 C64,129 62,127 62,124 ' +
    'L62,58 L56,66 L49,56 C47,53 47,50 49,47 L66,31 C72,27 78,25 87,24 ' +
    'L100,45 L113,24 Z';

  /* El mismo cuerpo, pero sin mangas: los hombros se estrechan a tirantes y la
     sisa baja en curva hasta la línea del pecho. El ancho del cuerpo y la altura
     son los de la camiseta a propósito, para que una misma impresión se vea del
     mismo tamaño en las dos prendas y se puedan comparar. */
  var TIRANTES = 'M113,24 L120,25 C116,40 126,52 138,70 ' +
    'L138,124 C138,127 136,129 133,129 L67,129 C64,129 62,127 62,124 ' +
    'L62,70 C74,52 84,40 80,25 L87,24 C90,31 110,31 113,24 Z';

  /* LOS MODELOS que se compran al proveedor, con su tabla de tallas.
   *
   * Un modelo NO es lo mismo que una prenda: "camiseta" es la silueta que se
   * dibuja, y el modelo es la referencia concreta del catálogo del proveedor,
   * con sus tallas y sus medidas. Varios productos de la tienda pueden ser el
   * mismo modelo —la unitaria, la laboral y los packs son todos TS150ST— y a
   * la vez habrá camisetas de otro modelo con otras tallas.
   *
   * Cada producto dice cuál es el suyo en el metafield custom.modelo. Añadir un
   * modelo nuevo es copiar aquí la tabla de su ficha técnica y añadirlo a las
   * opciones del metafield: nada más.
   *
   * Las medidas son EN PLANO, [ancho, largo] en cm. El ancho va de costura a
   * costura por debajo de la sisa, que es como se mide una prenda estirada en
   * la mesa: es lo que el cliente puede comprobar con una camiseta suya y una
   * cinta métrica.
   */
  var MODELOS = {
    /* Camiseta de mujer manga corta, ligeramente entallada. Ficha técnica del proveedor
       (TSRLCMF, 29/09/2026): ancho y largo por talla, en cm. */
    tsrlcmf: {
      nombre: 'Camiseta mujer 150 g',
      tallas: {
        S: [42, 63], M: [44, 65], L: [46, 67], XL: [48, 69], XXL: [50, 71], '2XL': [50, 71]
      }
    },
    /* Top corto de mujer (Malia), 95 % algodón / 5 % elastano, 220 g. Ficha del proveedor
       (TSULMALIA, 30/09/2026): ancho y largo por talla, en cm. */
    tsulmalia: {
      nombre: 'Top corto mujer 220 g',
      tallas: {
        XS: [36, 37], S: [39, 39], M: [42, 40], L: [46, 42], XL: [50, 44]
      }
    },
    /* Camiseta de mujer con cuello de pico, manga corta, 145 g, ligeramente entallada.
       Ficha del proveedor (TSRLCMFP, 30/09/2026): ancho y largo por talla, en cm. */
    tsrlcmfp: {
      nombre: 'Camiseta mujer cuello de pico 145 g',
      tallas: {
        S: [42, 63], M: [44, 65], L: [46, 67], XL: [48, 69], XXL: [50, 71], '2XL': [50, 71]
      }
    },
    /* Camiseta de tirantes de mujer, espalda de nadador, 200 g, ligeramente entallada.
       Ficha del proveedor (TSULARB, 29/09/2026): ancho y largo por talla, en cm. */
    tsularb: {
      nombre: 'Camiseta de tirantes mujer 200 g',
      tallas: {
        XS: [36, 59], S: [38, 61], M: [40, 63], L: [42, 65], XL: [44, 67]
      }
    },
    /* Camiseta de tirantes (sin mangas) de hombre, 150-155 g. Ficha del proveedor
       (TSUASTRPM, 29/09/2026): ancho y largo por talla, en cm. */
    tsuastrpm: {
      nombre: 'Camiseta de tirantes 150 g',
      tallas: {
        S: [52, 66], M: [54, 68], L: [56, 70], XL: [58, 72], XXL: [60, 74], '2XL': [60, 74]
      }
    },
    /* Sudadera de cuello redondo de niño y niña, 290 g. Ficha del proveedor
       (SWRK290, 29/09/2026): ancho y largo por talla, en cm. */
    swrk290: {
      nombre: 'Sudadera niño 290 g',
      tallas: {
        '1-2': [33, 40], '3-4': [36, 43], '5-6': [39, 46], '7-8': [42, 53], '9-11': [46, 58], '12-14': [50, 61]
      }
    },
    /* Sudadera de cuello redondo unisex 290 g. Ficha del proveedor (SWRA290, 30/09/2026):
       ancho y largo por talla, en cm. */
    swra290: {
      nombre: 'Sudadera lisa 290 g',
      tallas: {
        XS: [51, 63], S: [54, 66], M: [57, 69], L: [60, 72], XL: [63, 76], XXL: [66, 78], '2XL': [66, 78],
        XXXL: [70, 81], '3XL': [70, 81], '4XL': [73, 83], '5XL': [76, 85]
      }
    },
    /* Sudadera corta con capucha oversize de mujer 290 g. Ficha del proveedor (SWULCROP,
       30/09/2026): ancho y largo por talla, en cm. */
    swulcrop: {
      nombre: 'Sudadera corta oversize mujer 290 g',
      tallas: {
        XS: [56, 45], S: [58, 46], M: [60, 48], L: [62, 50]
      }
    },
    /* Camiseta de niño y niña 190 g. Ficha técnica del proveedor (TSRK190, 29/09/2026):
       ancho y largo por talla, en cm. Las tallas son las del proveedor, por edad. */
    /* Body de bebé de manga corta (TSRBBODY). Ficha de JHK que pasó Xavi el 30/09/2026: ancho y
       largo por talla en cm. La tienda vende las tallas como «3 meses»…; van las dos formas. */
    tsrbbody: {
      nombre: 'Body bebé',
      tallas: {
        '3M': [20, 38], '6M': [22, 40], '9M': [24, 42], '12M': [26, 44], '18M': [28, 46],
        '3 meses': [20, 38], '6 meses': [22, 40], '9 meses': [24, 42], '12 meses': [26, 44], '18 meses': [28, 46]
      }
    },
    /* Body de bebé de manga larga (TSRBODYLS). Tabla que pasó Xavi el 30/09/2026 (captura de JHK): coincide con la del
       body de manga corta. Van las dos formas de nombrar la talla. */
    tsrbbodyls: {
      nombre: 'Body bebé manga larga',
      tallas: {
        '3M': [20, 38], '6M': [22, 40], '9M': [24, 42], '12M': [26, 44], '18M': [28, 46],
        '3 meses': [20, 38], '6 meses': [22, 40], '9 meses': [24, 42], '12 meses': [26, 44], '18 meses': [28, 46]
      }
    },
    /* Camiseta de bebé TSRB150 (ficha de JHK que pasó Xavi el 30/09/2026): ancho y largo por talla en cm.
       JHK las llama 0, 1 y 2 sin decir la edad. */
    tsrb150: {
      nombre: 'Camiseta bebé',
      tallas: { '0': [23, 34], '1': [25, 35], '2': [30, 37] }
    },
    tsrk190: {
      nombre: 'Camiseta niño 190 g',
      tallas: {
        '3-4': [32, 44], '5-6': [35, 49], '7-8': [38, 52], '9-11': [41, 58], '12-14': [43, 61]
      }
    },
    tsrk150ls: {
      nombre: 'Camiseta niño manga larga 155 g',
      tallas: {
        '1-2': [29, 39], '3-4': [32, 44], '5-6': [35, 49], '7-8': [38, 52], '9-11': [41, 58], '12-14': [43, 61]
      }
    },
    ts150st: {
      nombre: 'Camiseta 150 g',
      tallas: {
        S: [48, 69], M: [51, 70], L: [53, 73], XL: [56, 75],
        XXL: [59, 77], '2XL': [59, 77], '3XL': [61, 79], '4XL': [66, 82], '5XL': [68, 84]
      }
    },
    /* Deportiva de poliéster reciclado 130 g, manga raglán. Medidas de la ficha
       técnica del proveedor del 24/09/2026. El salto del largo entre XL y XXL
       (74 → 79) viene así en su ficha; si algún cliente se queja de que la XXL
       le queda larga, es eso y no un error de aquí. */
    sportman: {
      nombre: 'Camiseta deportiva 130 g',
      tallas: {
        S: [50, 68], M: [52, 70], L: [54, 72], XL: [56, 74],
        XXL: [58, 79], '2XL': [58, 79], '3XL': [60, 81]
      }
    },
    /* Polo piqué de 210 g, tapeta de 2 botones y aberturas laterales.
       La ficha técnica del proveedor llama XS a la talla pequeña y la tienda la
       vende como XXS: van las dos, porque si el nombre no coincide exactamente
       esa talla se queda sin guía de medidas y no se entera nadie. */
    pora210: {
      nombre: 'Polo piqué 210 g',
      tallas: {
        XXS: [47, 68], XS: [47, 68], S: [51, 70], M: [53, 72], L: [55, 74], XL: [59, 76],
        XXL: [63, 80], '2XL': [63, 80], '3XL': [65, 82], '4XL': [67, 84], '5XL': [71, 86]
      }
    },
    /* Polo Premium piqué de 240 g (PORA240). Ficha del proveedor (descargada el 01/10):
       mismas medidas que el de 210 g, de XS a 3XL. */
    pora240: {
      nombre: 'Polo Premium piqué 240 g',
      tallas: {
        XS: [47, 68], S: [51, 70], M: [53, 72], L: [55, 74], XL: [59, 76],
        XXL: [63, 80], '2XL': [63, 80], '3XL': [65, 82]
      }
    },
    /* Manga larga de 155 g, tubular. Mismas medidas de cuerpo que la 190 g:
       es el mismo patrón con otro tejido. */
    tsra150ls: {
      nombre: 'Camiseta manga larga 155 g',
      tallas: {
        XS: [48, 68], S: [51, 70], M: [53, 72], L: [56, 74], XL: [58, 76],
        XXL: [61, 78], '2XL': [61, 78], '3XL': [66, 82], '4XL': [68, 84], '5XL': [72, 88]
      }
    },
    /* La de cuello de pico, 160 g. */
    tsuapico: {
      nombre: 'Camiseta cuello de pico 160 g',
      tallas: {
        S: [48, 70], M: [51, 72], L: [53, 74], XL: [56, 76],
        XXL: [58, 80], '2XL': [58, 80]
      }
    },
    /* La gruesa de 185-190 g, tejido tubular (sin costuras laterales) y
       refuerzo de hombro a hombro. */
    tsra170: {
      nombre: 'Camiseta 170 g',
      tallas: {
        XS: [48, 68], S: [51, 70], M: [53, 72], L: [56, 74], XL: [58, 76],
        XXL: [61, 78], '2XL': [61, 78], '3XL': [66, 82], '4XL': [68, 84], '5XL': [72, 88]
      }
    },
    /* Camiseta técnica Roly Montecarlo (CA0425), ficha 26/09/2026: ancho medido
       1 cm bajo la manga, largo desde el hombro. */
    ca0425: {
      nombre: 'Camiseta técnica Montecarlo',
      tallas: {
        S: [48, 71], M: [51, 72], L: [54, 73], XL: [57, 74],
        XXL: [60, 75], '2XL': [60, 75], '3XL': [63, 76]
      }
    },
    /* Chaleco softshell Roly Nevada (RA1199), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ra1199: {
      nombre: 'Chaleco softshell',
      tallas: {
        S: [52, 72], M: [55, 74], L: [58, 76], XL: [62, 77],
        XXL: [65, 78], '2XL': [65, 78], '3XL': [69, 79]
      }
    },
    /* Bellagio RA1099 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ra1099: {
      nombre: 'Bellagio',
      tallas: {
        S: [50, 65], M: [53, 67], L: [56, 69], XL: [59, 71], '2XL': [62, 73], '3XL': [65, 75], XXL: [62, 73]
      }
    },
    /* New Artic Woman CQ6415 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    cq6415: {
      nombre: 'New Artic Woman',
      tallas: {
        S: [47, 64], M: [50, 66], L: [53, 68], XL: [57, 71], '2XL': [62, 74], XXL: [62, 74]
      }
    },
    /* Urban Woman SU1068 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    su1068: {
      nombre: 'Urban Woman',
      tallas: {
        S: [50, 65], M: [53, 67], L: [56, 69], XL: [59, 71], '2XL': [63, 74], XXL: [63, 74]
      }
    },
    /* Beagle CA6554 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ca6554: {
      nombre: 'Beagle',
      tallas: {
        XS: [46, 66], S: [49, 69], M: [52, 71], L: [55, 73], XL: [58, 75], '2XL': [62, 77], '3XL': [66, 79], '4XL': [70, 81], '5XL': [74, 83], XXL: [62, 77]
      }
    },
    /* Panacea CA9098 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ca9098: {
      nombre: 'Panacea',
      tallas: {
        XS: [54, 72], S: [57, 73], M: [60, 74], L: [63, 75], XL: [67, 76], '2XL': [71, 78], '3XL': [75, 80], XXL: [71, 78]
      }
    },
    /* Oslo RA5092 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ra5092: {
      nombre: 'Oslo',
      tallas: {
        S: [53, 66], M: [56, 68], L: [58, 70], XL: [62, 72], '2XL': [65, 74], '3XL': [69, 75], '4XL': [73, 76], XXL: [65, 74]
      }
    },
    /* Monzha Woman PO0410 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    po0410: {
      nombre: 'Monzha Woman',
      tallas: {
        S: [41, 60], M: [44, 62], L: [47, 64], XL: [50, 66], '2XL': [53, 68], XXL: [53, 68]
      }
    },
    /* Arzak DE9091 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    de9091: {
      nombre: 'Arzak',
      tallas: {
        UNICA: [53, 84]
      }
    },
    /* New Artic CQ6414 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    cq6414: {
      nombre: 'New Artic',
      tallas: {
        S: [52, 69], M: [55, 71], L: [58, 73], XL: [63, 75], '2XL': [67, 78], '3XL': [71, 81], '4XL': [75, 83], XXL: [67, 78]
      }
    },
    /* Antartida SS6432 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ss6432: {
      nombre: 'Antartida',
      tallas: {
        S: [53, 74], M: [55, 75], L: [58, 76], XL: [62, 77], '2XL': [65, 78], '3XL': [67, 79], XXL: [65, 78]
      }
    },
    /* Antartida Woman SS6433 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ss6433: {
      nombre: 'Antartida Woman',
      tallas: {
        S: [48, 64], M: [50, 66], L: [53, 68], XL: [55, 69], '2XL': [58, 70], '3XL': [60, 72], XXL: [58, 70]
      }
    },
    /* Himalaya SM1095 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    sm1095: {
      nombre: 'Himalaya',
      tallas: {
        XS: [46, 70], S: [50, 71], M: [54, 72], L: [58, 73], XL: [62, 74], '2XL': [66, 75], '3XL': [70, 76], XXL: [66, 75]
      }
    },
    /* Quebec SS6438 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ss6438: {
      nombre: 'Quebec',
      tallas: {
        XS: [49, 73], S: [52, 74], M: [55, 75], L: [58, 76], XL: [62, 77], '2XL': [66, 78], '3XL': [70, 79], XXL: [66, 78]
      }
    },
    /* JHK FLRA300, ficha técnica: ancho y largo por talla (alta_jhk.py). */
    flra300: {
      nombre: 'FLRA300',
      tallas: {
        XS: [54, 67], S: [56, 69], M: [58, 71], L: [60, 73], XL: [62, 75], XXL: [64, 77], '3XL': [66, 83], '2XL': [64, 77]
      }
    },
    /* JHK FLRL300, ficha técnica: ancho y largo por talla (alta_jhk.py). */
    flrl300: {
      nombre: 'FLRL300',
      tallas: {
        XS: [45, 59], S: [47, 61], M: [50, 63], L: [52, 65], XL: [55, 67], XXL: [57, 69], '2XL': [57, 69]
      }
    },
    /* JHK SOFTJACK, ficha técnica: ancho y largo por talla (alta_jhk.py). */
    softjack: {
      nombre: 'SOFTJACK',
      tallas: {
        S: [53, 70], M: [55, 72], L: [57, 74], XL: [59, 76], XXL: [61, 78], '3XL': [63, 80], '4XL': [65, 82], '2XL': [61, 78]
      }
    },
    /* JHK SOFTJACKL, ficha técnica: ancho y largo por talla (alta_jhk.py). */
    softjackl: {
      nombre: 'SOFTJACKL',
      tallas: {
        S: [47, 61], M: [50, 63], L: [52, 65], XL: [55, 67]
      }
    },
    /* JHK SOFTVEST, ficha técnica: ancho y largo por talla (alta_jhk.py). */
    softvest: {
      nombre: 'SOFTVEST',
      tallas: {
        S: [53, 70], M: [55, 72], L: [57, 74], XL: [59, 76], XXL: [61, 78], '2XL': [61, 78]
      }
    },
    /* JHK SWCR240, ficha técnica: ancho y largo por talla (alta_jhk.py). */
    swcr240: {
      nombre: 'SWCR240',
      tallas: {
        S: [54, 66], M: [57, 69], L: [60, 72], XL: [63, 76], XXL: [66, 78], '3XL': [70, 81], '2XL': [66, 78]
      }
    },
    /* JHK SWKNG240, ficha técnica: ancho y largo por talla (alta_jhk.py). */
    swkng240: {
      nombre: 'SWKNG240',
      tallas: {
        S: [54, 69], M: [56, 70], L: [58, 71], XL: [60, 72], XXL: [62, 74], '3XL': [64, 76], '2XL': [62, 74]
      }
    },
    /* JHK SWULKNG, ficha técnica: ancho y largo por talla (alta_jhk.py). */
    swulkng: {
      nombre: 'SWULKNG',
      tallas: {
        S: [48, 66], M: [50, 68], L: [52, 70], XL: [54, 72], XXL: [56, 74], '2XL': [56, 74]
      }
    },
    /* JHK SWRAKNG, ficha técnica: ancho y largo por talla (alta_jhk.py). */
    swrakng: {
      nombre: 'SWRAKNG',
      tallas: {
        XS: [52, 68], S: [54, 69], M: [56, 70], L: [58, 71], XL: [60, 72], XXL: [62, 74], '3XL': [64, 76], '4XL': [67, 78], '5XL': [69, 80], '2XL': [62, 74]
      }
    },
    /* Chow CA6561 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ca6561: {
      nombre: 'Chow',
      tallas: {
        XS: [51, 72], S: [54, 74], M: [57, 76], L: [60, 78], XL: [63, 80], '2XL': [66, 82], '3XL': [69, 84], XXL: [66, 82]
      }
    },
    /* Bugatti CA6399 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ca6399: {
      nombre: 'Bugatti',
      tallas: {
        S: [48, 68], M: [51, 70], L: [54, 72], XL: [57, 74], '2XL': [60, 76], XXL: [60, 76]
      }
    },
    /* Bahrain Woman CA0408 (alta_prenda.py), ficha: ancho 1 cm bajo la sisa, largo desde el hombro. */
    ca0408: {
      nombre: 'Bahrain Woman',
      tallas: {
        S: [42, 62], M: [45, 64], L: [48, 66], XL: [51, 68], '2XL': [54, 70], XXL: [54, 70]
      }
    },
    tsra190: {
      nombre: 'Camiseta 190 g',
      tallas: {
        XS: [48, 68], S: [51, 70], M: [53, 72], L: [56, 74], XL: [58, 76],
        XXL: [61, 78], '2XL': [61, 78], '3XL': [66, 82], '4XL': [68, 84], '5XL': [72, 88]
      }
    },
    /* Oversize de 240 g, corte relaxed. Ojo al leer esta tabla: una S de
       oversize mide 55 cm de ancho, más que una XL normal. No es un error de
       la ficha, es el corte. */
    tsuaover240: {
      nombre: 'Camiseta oversize 240 g',
      tallas: {
        XS: [52, 70], S: [55, 72], M: [57, 75], L: [60, 77],
        XL: [63, 79], XXL: [67, 81], '2XL': [67, 81]
      }
    },
    /* Oversize de 200 g (TSUAOVER, Urban Oversize). Ficha del proveedor, 08/10/2026. Más ligera que la de 240 g. */
    tsuaover: {
      nombre: 'Camiseta oversize 200 g',
      tallas: {
        XS: [53, 72], S: [56, 74], M: [59, 76], L: [62, 78],
        XL: [65, 80], XXL: [68, 82], '2XL': [68, 82]
      }
    },
    /* Sudadera con capucha y bolsillo canguro, 320 g, unisex. Ficha técnica
       del proveedor que pasó Xavi el 27/09/2026. La tienda vende la 2XL como
       «2XL» y la ficha la llama XXL: van las dos. */
    swkng320: {
      nombre: 'Sudadera con capucha 320 g',
      tallas: {
        XS: [52, 68], S: [54, 69], M: [56, 70], L: [58, 71], XL: [60, 72],
        XXL: [62, 74], '2XL': [62, 74], '3XL': [64, 76]
      }
    },
    /* La oversize con capucha, 320 g, cuello cruzado. Ficha del 27/09/2026.
       Mismo largo que la normal pero 8-14 cm más ancha: una S oversize (60)
       es más ancha que una XL normal (60). No es un error de la ficha, es el
       corte. En la ficha de producto se dibuja con la misma foto que la
       normal (misma plantilla ropa-sudadera): las zonas de impresión son
       las mismas, y la foto de una oversize distinta no la hay. */
    swkngover: {
      nombre: 'Sudadera oversize con capucha 320 g',
      tallas: {
        XS: [56, 68], S: [60, 69], M: [64, 70], L: [68, 71], XL: [72, 72],
        XXL: [76, 74], '2XL': [76, 74]
      }
    },
    /* Cremallera entera, cuello alto, 290 g, bolsillos laterales. Ficha del
       27/09/2026. Más larga que las de capucha (78 en XXL). En la tienda aún
       no hay producto con este modelo (27/09): la de media cremallera es
       otra referencia, sin ficha todavía. */
    swrafuzip: {
      nombre: 'Sudadera cremallera entera 290 g',
      tallas: {
        XS: [52, 67], S: [54, 69], M: [56, 72], L: [58, 74], XL: [60, 76],
        XXL: [62, 78], '2XL': [62, 78]
      }
    },
    /* Media cremallera, cuello alto, 290 g. Ficha del 27/09/2026. Solo va
       de S a XXL, que es lo que vende la tienda. */
    swrazip: {
      nombre: 'Sudadera media cremallera 290 g',
      tallas: {
        S: [54, 66], M: [57, 69], L: [60, 72], XL: [63, 76],
        XXL: [66, 78], '2XL': [66, 78]
      }
    }
  };

  // la tabla de tallas de un modelo; sin modelo o desconocido, no hay guía
  function tallasDe(modelo) {
    var m = MODELOS[String(modelo || '').trim().toLowerCase()];
    return (m && m.tallas) || null;
  }

  var PRENDAS = {
    camiseta: {
      /* CON FOTO desde el 26/09 (delante y detrás del catálogo del proveedor,
         jaspeado suavizado y etiqueta de marca borrada). Escala por el LARGO,
         como las sudaderas: en la foto el cuerpo se ve más estrecho de lo que
         es (maniquí invisible), así que anchoRealCm es el ancho VISIBLE. Se
         toma 70 cm de largo (talla M) hasta tener la ficha técnica. La axila
         de colocación, a 18 cm del cuello. */
      anchoRealCm: 38.1, cuerpo: [62, 138], caja: [43.5, 24.0, 157.1, 163.8], axila: 70.4,
      foto: {"x": 43.53, "y": 24.0, "w": 113.61, "h": 139.83},
      fotoEspalda: {"x": 44.08, "y": 25.66, "w": 111.18, "h": 138.17, "silueta": "M58.6,39.7 L56.9,41.3 L53.4,48.6 L45.1,69.7 L44.1,73.6 L61.2,79.5 L62.7,108.1 L63.3,143.0 L63.2,161.1 L63.7,162.1 L66.0,163.4 L74.5,163.7 L134.3,163.6 L136.2,163.2 L137.4,161.6 L137.1,131.1 L137.9,98.7 L138.9,79.5 L148.6,76.4 L155.1,73.7 L148.1,50.9 L144.2,41.7 L142.4,40.0 L139.3,38.4 L116.0,30.4 L111.6,26.4 L104.9,25.7 L93.9,26.0 L90.0,26.5 L88.2,27.3 L86.2,29.8 L84.5,31.0 L62.9,37.8 Z"},
      silueta: 'M142.5,35.1 L134.6,31.9 L118.4,27.1 L116.0,25.9 L114.3,24.0 L105.9,25.7 L97.7,25.9 L90.1,25.3 L85.8,24.1 L84.0,25.9 L82.1,26.9 L71.3,30.1 L61.7,33.6 L58.8,35.2 L56.6,37.6 L54.0,42.5 L50.9,50.1 L43.7,70.8 L43.5,72.5 L61.2,77.5 L62.1,93.6 L62.4,122.6 L62.1,162.7 L62.4,163.3 L112.1,163.7 L136.6,163.5 L137.6,163.2 L137.2,132.4 L137.9,113.8 L138.0,89.8 L138.8,78.5 L157.0,73.2 L153.3,58.5 L149.3,46.5 L145.6,38.6 Z',
      // el jaspeado deja el cuello sin contraste: sobre la foto se marca flojo
      lineasFoto: ['M83.1,25.1 C86.1,34.8 114.4,34.8 117.4,25.1', 'M87.6,25.8 C90.5,29.8 110.0,29.8 113.0,25.8'],
      lineasFotoEspalda: ['M83.7,25.3 C87.0,27.9 113.6,27.9 116.9,25.3'],
      lineas: ['M83.1,25.1 C86.1,34.8 114.4,34.8 117.4,25.1', 'M87.6,25.8 C90.5,29.8 110.0,29.8 113.0,25.8'],
      lineasEspalda: ['M83.7,25.3 C87.0,27.9 113.6,27.9 116.9,25.3', 'M97.5,26.4 L102.5,26.4 L102.5,28.4 L97.5,28.4 Z']
    },
    'manga-larga': {
      anchoRealCm: 51, cuerpo: [62, 138], caja: [47, 22, 153, 131], axila: 58,
      silueta: LARGA,
      // cuello y los canalés de los puños
      lineas: ['M87,24 C90,31 110,31 113,24', 'M141,96 L150,96', 'M50,96 L59,96'],
      lineasEspalda: ['M86,25 C91,29 109,29 114,25', 'M95,30 L105,30 L105,37 L95,37 Z',
                      'M141,96 L150,96', 'M50,96 L59,96']
    },
    /* Cuello de pico. Mismo cuerpo que la camiseta: lo único que cambia es el
       escote, pero es lo primero que mira quien compra esta prenda. */
    pico: {
      anchoRealCm: 51, cuerpo: [62, 138], caja: [47, 22, 153, 131], axila: 58,
      silueta: PICO,
      // el canalé del escote, por dentro del pico
      lineas: ['M89,25 L100,42 L111,25'],
      lineasEspalda: ['M86,25 C91,29 109,29 114,25', 'M95,30 L105,30 L105,37 L95,37 Z']
    },
    tirantes: {
      /* Más estrecha de cuerpo que la camiseta: es entallada. Las zonas de
         manga no se ofrecen en estas fichas (metafield `custom.zonas`), pero
         aunque se ofrecieran no habría dónde ponerlas. */
      anchoRealCm: 44, cuerpo: [62, 138], caja: [47, 22, 153, 131], axila: 58,
      silueta: TIRANTES,
      // el ribete del escote, que es lo que distingue a esta prenda de cerca
      lineas: ['M87,24 C90,31 110,31 113,24', 'M89,26 C92,32 108,32 111,26'],
      lineasEspalda: ['M86,25 C91,29 109,29 114,25', 'M95,30 L105,30 L105,37 L95,37 Z']
    },
    polo: {
      anchoRealCm: 50, cuerpo: [62, 138], caja: [47, 22, 153, 131], axila: 58,
      silueta: CUERPO,
      lineas: ['M87,24 L100,42 L113,24', 'M96,40 L96,70', 'M104,40 L104,70'],
      puntos: [[100, 50, 1.9], [100, 62, 1.9]],
      lineasEspalda: ['M86,25 C91,29 109,29 114,25', 'M95,30 L105,30 L105,37 L95,37 Z']
    },
    /* SUDADERA CORTA OVERSIZE de mujer, con capucha: la FOTO de catálogo que
       pasó Xavi el 27/09, recoloreada (antes era un dibujo de cuello redondo,
       y la prenda lleva capucha). Lo que la distingue es que el cuerpo acaba
       en la cintura: el bajo queda a ~110, no a ~165 como en las otras.
       ESCALA por el LARGO, con la ficha técnica que pasó Xavi (SWULCROP, talla M:
       60 de ancho, 48 de largo): del cuello al bajo hay 73,1 unidades = 48 cm. Entre
       costura y costura se ven ~50 cm (maniquí invisible), por eso
       anchoRealCm es el ancho VISIBLE. La axila de colocación, a 18 cm del
       cuello, como en las demás. */
    'sudadera-corta': {
      anchoRealCm: 49.9, cuerpo: [62, 138], caja: [41, 21.5, 159.4, 168], axila: 64.3,
      foto: {"x": 41.85, "y": 22.0, "w": 117.02, "h": 145.97},
      fotoEspalda: {"x": 41.13, "y": 21.52, "w": 118.22, "h": 146.09, "silueta": "M75.3,22.2 L74.4,24.2 L73.5,35.1 L72.9,36.8 L68.6,39.5 L66.6,41.9 L62.7,54.5 L62.7,56.3 L52.1,98.6 L44.1,134.6 L41.3,151.9 L41.4,154.6 L42.0,155.2 L42.2,157.5 L41.1,164.0 L43.1,165.2 L49.7,167.2 L52.8,167.5 L53.7,166.8 L55.6,161.6 L60.3,155.8 L66.8,142.4 L70.9,129.6 L73.7,117.8 L74.3,113.0 L88.4,112.4 L108.3,112.4 L125.5,113.3 L128.3,125.7 L132.8,140.9 L138.8,154.0 L141.0,157.6 L144.2,161.1 L146.8,166.9 L147.8,167.5 L150.2,167.1 L158.7,164.8 L159.2,163.9 L158.1,156.7 L159.0,155.2 L159.1,153.6 L158.5,148.1 L153.2,120.4 L147.3,94.6 L139.2,61.6 L138.1,55.5 L134.6,44.1 L132.2,40.2 L130.5,38.8 L128.3,37.8 L127.1,36.1 L125.8,22.5 L124.2,21.8 L121.8,21.5 L99.8,21.9 L78.4,21.5 Z"},
      /* Por detrás la capucha cae hasta ~64 (su pico, medido en la foto). */
      espaldaDesde: 66,
      /* Bajo la capucha quedan ~30 cm de espalda: la grande se queda en 30×28
         y la lumbar y el dorsal no caben (el cuerpo acaba antes). */
      cajasZona: { espalda: [[30, 28]] },
      sinZonas: ['espalda-lumbar', 'dorsal'],
      silueta: 'M75.4,22.5 L74.4,24.3 L72.9,37.1 L68.4,39.6 L66.2,42.1 L64.5,46.0 L61.0,57.0 L60.8,60.5 L51.9,98.6 L44.3,136.7 L41.9,152.8 L42.0,155.9 L42.9,157.2 L42.9,159.2 L41.9,164.0 L42.1,165.0 L42.7,165.4 L52.0,167.7 L53.9,167.7 L54.9,167.1 L57.7,160.4 L59.2,158.8 L62.7,152.3 L68.8,137.0 L75.0,110.2 L108.4,109.8 L125.5,110.3 L129.4,128.4 L132.0,137.3 L138.0,152.4 L141.5,158.9 L143.5,161.1 L145.8,167.1 L146.6,167.7 L148.0,167.8 L158.3,165.3 L158.7,164.0 L157.5,157.5 L158.6,155.8 L158.7,153.9 L156.9,140.9 L148.7,100.3 L139.3,61.0 L139.0,57.5 L133.5,42.0 L131.4,39.5 L127.1,37.1 L125.0,23.1 L124.1,22.5 L121.1,22.0 L78.5,22.0 Z',
      lineas: [],
      lineasEspalda: []
    },
    sudadera: {
      /* CALCADA de la foto de catálogo que pasó Xavi el 26/09 (capucha con
         cordones, hombro caído, bolsillo canguro, canalé en puños y bajo).
         Delante se pinta con la FOTO recoloreada; detrás, con el calco hasta
         que haya foto de espalda. La axila es de colocación, no de costura:
         a la misma distancia del cuello que en la camiseta. */
      /* ESCALA, con la ficha técnica del proveedor (SWKNG320, talla L: 58 cm
         de ancho y 71 de largo), que pasó Xavi el 27/09. Misma casa y misma
         foto que la lisa, así que se calibra igual: por el LARGO (cuello a
         bajo = 135,5 unidades = 71 cm). Un centímetro menos de largo que la
         lisa, y con él el ancho visible baja de 40,4 a 39,8. */
      anchoRealCm: 39.8, cuerpo: [62, 138], caja: [48.3, 22.0, 150.6, 167.1], axila: 79.5,
      foto: {"x": 48.32, "y": 22.0, "w": 102.31, "h": 145.1},
      fotoEspalda: {"x": 48.32, "y": 23.05, "w": 102.19, "h": 144.05, "silueta": "M76.0,26.3 L74.0,27.7 L73.2,29.6 L71.9,36.0 L71.9,40.1 L72.4,42.3 L62.0,46.8 L57.2,49.5 L55.2,51.5 L53.3,57.3 L51.4,74.5 L49.5,103.4 L48.3,150.1 L48.9,152.1 L49.0,161.6 L50.2,162.3 L53.8,162.8 L63.9,162.5 L64.5,164.9 L66.8,165.8 L87.5,167.0 L111.1,167.0 L128.1,166.3 L134.0,165.1 L134.5,164.8 L134.7,162.8 L135.2,162.5 L145.0,162.8 L149.2,162.1 L149.8,160.6 L149.9,151.4 L150.4,151.2 L149.2,102.1 L147.1,71.1 L145.5,57.4 L143.4,51.3 L141.6,49.5 L138.1,47.4 L127.2,42.7 L127.2,38.3 L126.1,35.1 L125.6,29.7 L124.8,27.7 L122.6,26.3 L113.2,24.1 L101.2,23.1 L91.0,23.3 L84.9,24.2 Z"},
      /* Por detrás la capucha cae sobre la espalda hasta ~78 unidades (su pico,
         medido en la foto): ahí no se puede estampar, así que la espalda
         empieza por debajo. */
      espaldaDesde: 80,
      /* EL BOLSILLO CANGURO empieza en 114 (medido en la foto). Xavi, 27/09:
         «que el área pecho no pise el bolsillo» y luego «súbelo un poco y
         añade más área de altura». Con el reparto de siempre (1/4 por encima
         de la axila) un pecho centrado de 30 cm bajaba hasta 122. Aquí sube:
         0,44 del alto por encima de la axila. Así los 25 × 30 empiezan ~5 cm
         por debajo del cuello de la capucha y acaban ~1 cm antes del bolsillo.
         Un logo más bajo queda algo más arriba que en una sudadera lisa, que
         es lo que se busca: lejos del bolsillo. El delante grande, igual de
         alto (no se ofrece en estas fichas, pero si se marca no lo pisa). */
      bolsillo: 114,
      cajasZona: { 'delante-grande': [[30, 30]] },
      tercioZona: { 'pecho-centrado': 0.44, 'delante-grande': 0.44 },
      silueta: 'M74.9,25.7 L73.1,27.8 L73.0,30.4 L72.2,32.5 L71.8,41.4 L62.2,44.6 L56.9,47.6 L53.5,50.8 L51.9,57.0 L49.6,85.1 L48.8,104.4 L48.3,153.1 L49.0,162.1 L54.4,162.9 L63.6,162.8 L64.2,165.2 L65.4,166.3 L78.0,167.0 L120.3,167.0 L132.2,166.5 L134.3,165.7 L135.1,162.8 L144.2,162.9 L149.5,162.3 L150.0,159.5 L150.2,153.2 L150.5,152.8 L149.8,100.9 L149.1,84.7 L146.5,55.2 L145.2,50.6 L139.9,46.2 L135.9,44.3 L126.9,41.4 L127.0,36.0 L125.5,27.5 L124.1,25.9 L121.2,24.6 L110.2,22.5 L94.4,22.1 L85.5,22.8 L78.4,24.3 Z',
      lineas: ['M87.1,27.5 C81.9,40.9 92.4,47.4 100.0,47.4 C107.6,47.4 118.1,40.9 112.9,27.5',
               'M94.2,48.0 L92.4,86.5',
               'M106.4,48.0 L107.6,88.9',
               'M77.8,114.0 L121.0,114.0 L132.2,154.4 L67.8,154.4 Z',
               'M53.2,51.5 C58.5,57.3 61.4,67.8 62.0,78.4 L62.6,155.5',
               'M146.8,51.5 C141.5,57.3 138.6,67.8 138.0,78.4 L137.4,155.5',
               'M63.2,156.1 L136.8,156.1',
               'M48.9,152.6 L63.2,152.6',
               'M136.8,152.6 L150.3,152.6'],
      lineasEspalda: ['M73.7,49.1 C81.9,57.3 118.1,57.3 126.3,49.1',
               'M100.0,22.8 L100.0,55.0',
               'M53.2,51.5 C58.5,57.3 61.4,67.8 62.0,78.4 L62.6,155.5',
               'M146.8,51.5 C141.5,57.3 138.6,67.8 138.0,78.4 L137.4,155.5',
               'M63.2,156.1 L136.8,156.1',
               'M48.9,152.6 L63.2,152.6',
               'M136.8,152.6 L150.3,152.6']
    },
    /* La sudadera CLÁSICA, de cuello redondo. No es un detalle menor: de las
       seis sudaderas del catálogo, solo tres llevan capucha. Dibujar capucha y
       bolsillo a una de cuello redondo es enseñar una prenda que no es la que
       se compra. Lo que la distingue de una camiseta son los canalés: cuello,
       puños y bajo. */
    'sudadera-lisa': {
      /* CALCADA de la foto de catálogo que pasó Xavi el 26/09 (cuello redondo,
         hombro caído, canalé en cuello, puños y bajo), en vez de dibujada a
         ojo. Escala: el cuerpo, de costura a costura, son 76 unidades.
         OJO: la foto es de maniquí invisible, que estrecha el cuerpo por los
         lados; con eso y 56 cm de ancho sale un largo de ~90 cm, que es
         demasiado. Falta el ancho y el largo reales para calibrarla. */
      /* ESCALA, con la ficha técnica del proveedor (SWRA290, talla L: 60 cm de
         ancho y 72 de largo). En la foto de catálogo las mangas tapan los
         costados, así que entre costura y costura se ven ~40 cm de los 60: se
         calibra por el LARGO (cuello a bajo = 135,5 unidades = 72 cm), que no
         engaña. Por eso anchoRealCm es el ancho VISIBLE, no el de la tabla.
         La axila de colocación queda a 18 cm del cuello, como en la camiseta. */
      anchoRealCm: 40.4, cuerpo: [62, 138], caja: [49, 21, 151, 168], axila: 65.7,
      foto: {"x": 50.02, "y": 22.0, "w": 99.97, "h": 145.34},
      fotoEspalda: {"x": 49.9, "y": 26.21, "w": 100.09, "h": 141.24, "silueta": "M59.0,39.9 L58.7,40.7 L57.8,40.7 L57.8,41.4 L54.5,46.1 L52.9,50.8 L51.5,58.7 L50.8,70.5 L49.9,108.1 L49.9,139.0 L50.8,155.2 L52.2,159.2 L53.2,166.2 L54.3,167.3 L57.6,167.2 L65.3,165.8 L67.7,164.6 L66.9,158.1 L67.2,153.2 L68.1,153.2 L70.6,154.4 L75.2,155.1 L90.1,155.8 L110.2,155.8 L121.2,155.3 L128.1,154.6 L132.6,153.2 L132.9,154.2 L132.6,165.0 L135.5,166.0 L140.9,167.0 L145.5,167.0 L146.4,166.0 L146.6,162.8 L148.9,151.8 L149.9,133.1 L149.9,102.2 L148.9,68.8 L148.2,57.8 L146.8,50.4 L145.9,47.5 L144.1,44.2 L144.1,43.4 L143.7,43.4 L141.3,40.7 L137.1,38.3 L130.3,36.1 L126.5,35.4 L119.6,33.1 L116.0,31.5 L115.4,30.5 L114.6,30.5 L110.9,27.7 L105.3,26.3 L94.7,26.3 L91.5,26.8 L87.3,28.7 L85.1,30.8 L83.2,31.4 L82.2,32.4 L64.0,37.8 L59.8,39.9 Z"},
      silueta: 'M59.1,33.6 L56,36.3 L53.6,40 L51.8,54.5 L50.7,68.9 L50,97.6 L50.2,139.9 L51.1,154.2 L51.8,155.2 L52.2,166.4 L58.9,167.2 L63.8,166.9 L65.7,166.3 L66,165.6 L66.3,156.9 L67.3,156.8 L70.5,157.7 L75.3,158.2 L91.6,158.7 L118.1,158.7 L127.1,158.2 L133.3,157.3 L133.8,166.4 L139.9,167.2 L147.9,166.5 L148.1,155.8 L148.8,154 L149.6,139.2 L149.8,85.5 L148.2,55.9 L147.1,46.8 L145.3,39.2 L142.2,35.7 L137.7,33 L116.8,26.2 L113.9,24.9 L111.9,22.8 L106.6,22.2 L96.9,22 L86.8,22.6 L83.7,25.4 L75.3,28.3 L65.1,31 Z',
      lineas: ['M86.8,23.6 C89.8,29.7 110.2,29.7 113.2,23.6',
               'M82.8,25.0 C86.3,34.4 113.7,34.4 117.2,25.0',
               'M54.1,39.4 C58.4,42.3 61.5,45.3 61.7,49.4 L62.9,145.8',
               'M145.9,39.4 C141.6,42.3 138.5,45.3 138.3,49.4 L137.1,145.8',
               'M67.0,145.8 L133.6,145.8',
               'M51.0,154.6 L67.0,154.6',
               'M133.0,154.6 L149.0,154.6'],
      lineasEspalda: ['M82.8,25 C86.5,30 113.5,30 117.2,25', 'M95,27 L105,27 L105,34 L95,34 Z',
               'M54.1,39.4 C58.4,42.3 61.5,45.3 61.7,49.4 L62.9,145.8',
               'M145.9,39.4 C141.6,42.3 138.5,45.3 138.3,49.4 L137.1,145.8',
               'M67.0,145.8 L133.6,145.8',
               'M51.0,154.6 L67.0,154.6',
               'M133.0,154.6 L149.0,154.6']
    },
    /* Cremallera ENTERA y cuello alto (SWRAFUZIP). Xavi, 27/09: «mismo precio
       que la media cremallera» — sin foto de catálogo todavía, así que se
       dibuja con el cuerpo genérico (como la media cremallera antes de tener
       la suya): mismos anchoRealCm y axila, cambia solo la cremallera, que
       aquí baja entera hasta el bajo en vez de pararse a media altura. El
       centro del pecho no se ofrece (ahí va la cremallera), igual que en la
       media cremallera. */
    'sudadera-cremallera-entera': {
      anchoRealCm: 57, cuerpo: [62, 138], caja: [47, 22, 153, 131], axila: 58,
      silueta: CUERPO,
      lineas: ['M88,26 C91,33 109,33 112,26', 'M88,26 L88,17', 'M112,26 L112,17',
               'M88,17 C92,14 108,14 112,17', 'M100,30 L100,118',
               'M62,118 L138,118', 'M50,51 L57,61', 'M150,51 L143,61'],
      lineasEspalda: ['M86,25 C91,29 109,29 114,25', 'M62,118 L138,118',
                      'M50,51 L57,61', 'M150,51 L143,61']
    },
    /* Media cremallera y cuello alto. CALCADA de las fotos de catálogo que
       pasó Xavi el 27/09 (delante y detrás, prenda colgada, sin etiqueta).
       ESCALA, con la ficha SWRAZIP (talla M: 57 × 69): en la foto las mangas
       cuelgan pegadas al cuerpo y tapan los costados, así que, como en la
       lisa, se calibra por el LARGO (hombros a bajo = 69 cm) y se deja la
       misma escala que ella: 76 unidades = 40,4 cm visibles. Un logo de
       30 cm se ve grande sobre el cuerpo visible, pero mide lo que mide.
       La AXILA de colocación, a 18 cm del cuello como en las demás: el cuello
       alto sube hasta 22 y la línea de hombros está en 39,5 (medida en la
       foto), así que 39,5 + 18 × 1,882 = 73,4. Con el 58 del dibujo genérico
       la espalda quedaba 8 cm demasiado arriba («está muy arriba», Xavi). */
    'sudadera-cremallera': {
      anchoRealCm: 40.4, cuerpo: [62, 138], caja: [47.9, 22.0, 152.1, 169.1], axila: 73.4,
      foto: {"x": 47.86, "y": 22.0, "w": 104.29, "h": 147.12},
      fotoEspalda: {"x": 47.8, "y": 22.0, "w": 104.4, "h": 147.46, "silueta": "M88.1,23.1 L86.3,24.8 L86.2,27.1 L84.2,34.4 L82.6,34.6 L80.4,35.6 L67.2,38.1 L60.8,40.4 L56.1,44.2 L53.4,47.8 L51.8,51.0 L51.9,53.2 L50.6,61.8 L49.2,81.9 L47.8,114.0 L48.0,149.8 L48.6,152.8 L49.5,153.7 L50.1,155.3 L50.2,161.0 L49.7,163.5 L51.0,164.6 L53.8,165.1 L60.0,165.1 L64.2,164.3 L64.5,166.0 L65.7,167.8 L70.0,169.1 L81.8,169.0 L82.0,169.3 L82.1,169.0 L118.1,169.2 L128.6,168.9 L133.2,168.0 L135.2,166.3 L135.6,164.1 L139.6,164.8 L145.3,164.8 L148.8,164.2 L150.0,163.3 L149.7,155.5 L150.0,153.9 L151.3,152.3 L151.9,148.9 L152.1,114.9 L150.8,83.7 L149.2,61.6 L148.0,53.2 L148.1,50.6 L146.9,48.0 L143.8,43.8 L141.7,41.9 L138.8,40.3 L132.2,38.1 L123.6,36.3 L116.8,33.9 L114.5,28.8 L114.3,24.7 L112.4,23.0 L106.5,22.1 L96.8,22.0 L91.1,22.3 Z"},
      silueta: 'M88.0,22.6 L86.1,24.2 L85.8,28.5 L84.0,34.0 L79.7,35.4 L64.4,38.8 L60.1,40.5 L58.2,41.8 L55.8,44.2 L53.8,47.6 L53.2,50.3 L51.7,53.0 L51.8,54.6 L50.8,59.8 L50.6,68.3 L48.4,97.9 L47.9,115.3 L48.8,145.9 L49.4,152.1 L50.9,153.6 L51.5,155.3 L51.3,163.1 L52.5,163.9 L55.5,164.6 L60.5,164.8 L63.0,164.1 L63.4,162.3 L63.3,157.4 L64.2,150.1 L65.2,150.0 L65.9,157.1 L65.0,165.3 L65.6,167.2 L67.3,168.3 L79.3,169.0 L115.7,168.9 L131.7,168.3 L134.0,167.2 L134.6,165.0 L133.7,156.1 L134.3,149.8 L135.3,149.7 L135.6,154.6 L136.0,154.9 L136.4,157.2 L136.2,162.1 L136.8,163.8 L138.6,164.6 L144.3,164.5 L147.4,163.8 L148.4,163.0 L148.3,154.8 L149.0,153.2 L150.1,152.4 L150.6,150.9 L151.5,136.1 L152.0,115.4 L151.7,99.2 L149.6,60.9 L148.6,55.2 L148.7,53.5 L147.5,51.3 L146.8,48.2 L144.6,44.7 L142.4,42.4 L138.9,40.3 L132.7,38.1 L126.8,37.1 L118.6,35.0 L117.9,34.3 L116.8,34.0 L115.3,31.9 L114.1,27.0 L114.2,24.0 L113.2,23.2 L110.3,22.6 L103.9,22.0 Z',
      lineas: ['M88,26 C91,33 109,33 112,26', 'M88,26 L88,17', 'M112,26 L112,17',
               'M88,17 C92,14 108,14 112,17', 'M100,30 L100,64',
               'M62,118 L138,118', 'M50,51 L57,61', 'M150,51 L143,61'],
      lineasEspalda: ['M86,25 C91,29 109,29 114,25', 'M62,118 L138,118',
                      'M50,51 L57,61', 'M150,51 L143,61']
    },
    /* CALCADA (27/09) de la foto real que pasó Xavi: bolsa tote de 140 g/m²,
       algodón 100%. Antes era un rectángulo a ojo con un asa de un solo
       trazo; con la foto se corrigen las proporciones (el cuerpo salía
       11 unidades más largo de lo real) y el asa pasa a tener la forma de
       lazo de verdad —estrecha arriba, abriéndose hacia los hombros—, no
       un arco simétrico plano. */
    bolsa: {
      // color medido en la foto real (algodón crudo/crema, único color del modelo)
      colorPorDefecto: '#e8d9c0',
      anchoRealCm: 38, cuerpo: [58, 142], caja: [57.8, 32.0, 142.2, 187.1],
      silueta: 'M58,94 L142,94 L142,183 C142,185.5 140,187.1 137.5,187.1 ' +
        'L62.5,187.1 C60,187.1 58,185.5 58,183 Z',
      /* El asa, rellena de verdad (como la cinta del delantal): en negro
         (o cualquier color oscuro) el trazo suelto sale blanco por fuera
         de la bolsa, sobre fondo de página blanco, y no se ve nada
         (Xavi, 28/09, «cuando elijo negro no sale el asa»). */
      color: ['M83,94 C82,60 85,32 100,32 C115,32 118,60 117,94 ' +
              'L112,94 C113,63 111,37 100,37 C89,37 87,63 88,94 Z']
    },
    /* El delantal. Calcado (27/09) de la foto real del producto puesto: es
       bastante más alargado que lo que salía de las medidas A/B de la
       ficha (esa "B" se mide desde el hombro, no de cuello a bajo). El
       contorno del CUERPO es una curva suave sacada de la foto (puntos de
       ancho cada pocos cm, unidos con Catmull-Rom); intentarlo a mano con
       pocos puntos salía a trompicones.
       La CINTA del cuello no es tela: es un tirante fino con hueco de
       verdad por donde pasa la cabeza (Xavi, 27/09, «estás pintando donde
       no hay tela»), así que va aparte, en `color` como una cinta rellena
       de verdad (como el asa de la taza), no como relleno del cuerpo ni
       como trazo suelto —un trazo fino con transparencia blanca desaparece
       sobre fondo claro en la parte que cae fuera de la prenda.
       ESCALA por el ancho real (adulto: 70 cm), a 2 u/cm como las demás
       prendas; el largo sale de la proporción de la foto, no de la ficha.
       Xavi, 27/09: DTF en el pecho, centrado en la caja que marcó él sobre
       el modelo, 20×30 cm. */
    delantal: {
      anchoRealCm: 70, cuerpo: [30, 170], caja: [22, 14, 178, 377],
      silueta: 'M77.6,46.3 C74.5,54.9 72.6,65.8 71.2,75.6 C69.8,85.3 70.2,95.1 69.0,104.8 ' +
        'C67.8,114.5 66.0,124.3 64.3,134.0 C62.6,143.7 60.8,153.5 59.0,163.2 ' +
        'C57.2,172.9 55.2,182.7 53.5,192.4 C51.8,202.2 50.0,211.9 48.5,221.7 ' +
        'C47.0,231.4 45.6,241.2 44.2,250.9 C42.8,260.6 41.5,270.4 40.3,280.1 ' +
        'C39.1,289.8 38.1,299.6 36.9,309.3 C35.7,319.0 33.6,333.6 33.0,338.5 ' +
        'C31.0,365.6 37.0,369.6 43.0,369.6 L157.4,369.6 C163.4,369.6 169.4,365.6 167.4,338.5 ' +
        'C167.0,333.6 165.7,319.0 164.9,309.3 C164.1,299.6 163.3,289.8 162.5,280.1 ' +
        'C161.7,270.4 161.0,260.6 160.1,250.9 C159.2,241.2 158.1,231.4 157.1,221.7 ' +
        'C156.1,211.9 155.0,202.2 153.8,192.4 C152.7,182.7 151.4,172.9 150.2,163.2 ' +
        'C148.9,153.5 147.3,143.7 146.3,134.0 C145.3,124.3 144.6,114.5 144.0,104.8 ' +
        'C143.4,95.1 144.5,85.3 142.9,75.6 C141.3,65.8 140.0,54.9 134.5,46.3 ' +
        'C126.5,44.6 85.6,44.6 77.6,46.3 Z',
      // la cinta del cuello, con hueco de verdad, rellena del mismo color elegido
      color: ['M77.6,46.3 C74,30 85,16 100,16 C115,16 126,30 134.5,46.3 ' +
              'L129.5,46.3 C122,32 113,21 100,21 C87,21 78,32 82.6,46.3 Z'],
      // las cintas de cintura y el bolsillo partido en dos, a todo el ancho
      lineas: ['M63,167 L38,357', 'M144,167 L162,357',
               'M50,245 L150,245 L150,330 L50,330 Z', 'M100,245 L100,330']
    },
    /* La taza. Tres cosas que costaron un rediseño entero:
     *
     * 1 · Las PROPORCIONES. Estaba dibujada 76 de ancho por 122 de alto, o sea
     *     un vaso de tubo. Una taza de 330 ml mide 8,2 cm de diámetro por 9,5
     *     de alto: es casi cuadrada. Con las proporciones malas, un logo de 8 cm
     *     salía diminuto dentro de un vaso larguísimo y el cliente no se hacía
     *     ninguna idea del tamaño real.
     * 2 · El CUERPO VA CENTRADO en x=100 y el asa sobresale. Así, para enseñar
     *     la cara de la derecha basta con reflejar el dibujo (`espejo` en la
     *     zona): el cuerpo se queda donde está y solo cambia de lado el asa. Si
     *     el cuerpo estuviera descentrado, al reflejar se movería y las zonas
     *     apuntarían al aire.
     * 3 · La taza es REDONDA y el dibujo es plano, así que una sola escala no
     *     puede ser fiel a lo ancho y a lo alto a la vez: 9 cm de impresión son
     *     9 cm de arco, y vistos de frente se achatan a unos 7. Con el diámetro
     *     real (8,2 cm) el recuadro de 9 cm se salía del cuerpo y parecía un
     *     error. El ancho que se declara aquí, 9,8 cm, es el trozo de vuelta
     *     que representa la cara dibujada: con él una impresión de una cara
     *     llena la taza sin desbordarla, y la panorámica de 20 cm se sale por
     *     los dos lados, que es exactamente lo que hace al dar la vuelta.
     */
    taza: {
      anchoRealCm: 9.8, cuerpo: [63, 137], caja: [28, 72, 172, 166],
      /* El cuerpo salía más ancho que alto (66×74, casi cuadrado hacia el lado
         equivocado). Con la misma escala del ancho (9,8cm → 74px), los 9,5cm
         reales de alto piden 72px, no 66: el cuerpo crece hasta y=158/166 en
         vez de 152/160. De paso encaja con el asa, que ya estaba dibujada
         centrada en y=122 esperando un cuerpo así de alto. */
      silueta: 'M63,86 C63,81 80,78 100,78 C120,78 137,81 137,86 ' +
        'L137,158 C137,163 133,166 128,166 L72,166 C67,166 63,163 63,158 Z',
      /* El asa salía muy gorda: la cinta (hueco entre arco de fuera y de
         dentro) medía 9px de grosor y 10px en los puntos de unión al cuerpo.
         En una taza real el asa es una cinta fina, así que se adelgaza a la
         mitad: arco de fuera igual de grande (hasta x=168, un pelín menos
         que 172), arco de dentro mucho más cerca de él (hasta x=161, no
         163) y la unión al cuerpo pasa de 10px a 7px. */
      // el borde de la boca y el asa, con dos arcos para que tenga grosor
      lineas: ['M63,86 C63,91 80,94 100,94 C120,94 137,91 137,86',
               'M137,100 C161,100 168,109 168,122 C168,135 161,144 137,144',
               'M137,107 C153,107 161,113 161,122 C161,131 153,137 137,137'],
      /* LA TAZA DE COLOR NO ES UNA TAZA DE COLOR. Son blancas por fuera: lo que
         viene teñido es el ASA y el INTERIOR, que asoma por la boca. Se pintaba
         entera del color elegido y eso enseñaba un producto que no existe.
         `fondoImpresion` es además donde se imprime de verdad, así que el aviso
         de «tu logo no se va a ver» se mide contra el blanco y no contra el
         color del asa. */
      fondoImpresion: '#ffffff',
      // la boca: el óvalo entero, arriba y abajo, cerrado
      color: ['M63,86 C63,81 80,78 100,78 C120,78 137,81 137,86 ' +
              'C137,91 120,94 100,94 C80,94 63,91 63,86 Z',
      // el asa: el arco de fuera, y el de dentro al revés para que sea una cinta
              'M137,100 C161,100 168,109 168,122 C168,135 161,144 137,144 ' +
              'L137,137 C153,137 161,131 161,122 C161,113 153,107 137,107 Z']
    },
    /* La panorámica no es "la taza de frente, más ancha": es una pasada de
       plancha sobre el cuerpo DESARROLLADO, o sea la taza desenrollada en
       plano, sin asa (la plancha no envuelve el asa). Enseñar la vista de
       frente para colocar un diseño que da toda la vuelta engañaba: el
       cliente centraba el arte respecto a un asa que en la plancha real no
       está ahí.
       El dibujo es exactamente el área que se imprime, 20 × 9,5 cm (Xavi:
       dibujar también la vuelta completa de 25,8 cm dejaba dos franjas en
       blanco a los lados que liaban). 180 u = 20 cm → 9,5 cm = 85,5 u. */
    taza_panoramica: {
      anchoRealCm: 20, cuerpo: [10, 190], caja: [10, 40, 190, 125.5],
      silueta: 'M10,40 L190,40 L190,125.5 L10,125.5 Z',
      fondoImpresion: '#ffffff'
    },
    /* La gorra. Vista de frente: la copa (el "domo") con costura plana en la
       base, donde se une a la visera. Un solo panel frontal, un solo logo
       posible —no hay pecho/espalda ni tallas, talla única—, así que no hace
       falta el sistema de axilas de la ropa: la zona va con x,y fijos, igual
       que la bolsa. Silueta calcada de la foto real del modelo CABRAL
       (27/09); las dos costuras curvas son los paneles laterales, y la curva
       de abajo es el borde de la visera. */
    gorra: {
      /* Foto en gris (26/09→27/09 rehecha): la primera venía de una foto de
         la gorra AZUL, y un gris sacado de una tela azul queda mucho más
         oscuro que el tono medio (200) que usan las demás prendas, así que
         al teñir de otros colores salía sucio/falso. Xavi pasó una foto real
         del modelo en GRIS CLARO —el mismo tono base que usan camiseta y
         sudadera— y con esa se recalca: colores fieles en todo el catálogo. */
      anchoRealCm: 20, cuerpo: [55, 145], caja: [55.0, 38.0, 145.1, 110.8],
      foto: { x: 55.0, y: 38.0, w: 90.11, h: 72.76 },
      silueta: 'M64.7,55.5 L62.0,60.0 L60.2,64.9 L56.2,84.3 L55.0,103.9 L55.4,105.7 L57.7,109.3 L59.4,110.1 L62.7,110.1 L76.0,103.8 L80.6,102.3 L94.1,99.6 L101.6,99.0 L110.3,100.0 L118.3,102.2 L132.2,108.8 L136.2,110.3 L140.6,110.5 L142.0,110.0 L143.7,108.5 L144.8,106.0 L144.6,101.9 L145.0,99.3 L142.3,84.7 L140.6,69.8 L138.4,61.6 L136.4,56.5 L133.7,52.5 L129.1,48.4 L120.6,44.4 L109.3,41.7 L101.5,40.6 L100.5,38.8 L98.3,38.0 L96.3,38.0 L94.4,38.8 L93.6,40.7 L88.1,41.6 L82.7,43.0 L76.5,45.7 L68.4,51.1 Z',
      lineas: ['M55,109 C70,120 130,120 145,109',
               'M99,39 C90,64 85,95 85,109',
               'M99,39 C108,64 113,95 113,109']
    }
  };

  /* Dónde va cada impresión, EN CENTÍMETROS y respecto a dos referencias de la
   * prenda: el eje central y la LÍNEA DE LAS AXILAS. Así lo coloca el taller y
   * así se programa.
   *
   * No son coordenadas del dibujo a propósito: una coordenada fija centra el
   * logo en el cuerpo, y entonces un logo alto se va a la barriga. Colgándolo
   * de la línea de axilas, la posición es correcta con cualquier alto de logo
   * y en cualquier prenda, aunque cambie de largo.
   *
   * dx:     centímetros desde el eje (+ hacia el lado izquierdo de quien la
   *         lleva, que en un dibujo de frente cae a la derecha).
   * tercio: qué PARTE del alto de la impresión queda por encima de la línea de
   *         axilas. Las grandes llevan 1/4; el pecho izquierdo, 0,85, que lo
   *         deja casi entero por encima y cruzando la línea metro y medio.
   * bajo:   alternativa a "tercio" para lo que va MUY por debajo, como la
   *         lumbar: centímetros desde la línea de axilas hasta el borde de
   *         arriba de la impresión. Ahí la proporción no sirve —una lumbar no
   *         se coloca respecto a la axila sino respecto a la cintura— y lo que
   *         manda es una distancia fija.
   *
   * Lo importante es que NO se ancla el centro. Con el centro en la axila, una
   * impresión alta se sube hasta el cuello; y una distancia fija tampoco vale,
   * porque entonces un logo bajo se queda colgando. La proporción se ajusta
   * sola a cualquier alto de logo, que es como lo coloca el taller.
   *
   * Los anchos tienen techo en 30 cm: en un pecho de 51 cm, más de eso pisa las
   * sisas y ahí hay costura. Los dos tamaños de pecho se diferencian por el
   * alto, no por el ancho.
   *
   * Esto es el CATÁLOGO COMPLETO de zonas. Cada producto decide cuáles admite
   * con el metafield custom.zonas, que en el admin son casillas: se marcan los
   * ids de aquí. Vacío = todas. Así un polo se monta marcando dos casillas y
   * una camiseta de despedidas enseña solo las grandes, sin tocar código.
   *
   * Los ids se ven en el admin, por eso van escritos enteros.
   */
  var POSICIONES = {
    ropa: [
      { id: 'pecho-izquierdo', nombre: 'Pecho izquierdo', dx: 12.5, tercio: 0.85,
        cajas: [[10, 10]] },
      { id: 'pecho-derecho', nombre: 'Pecho derecho', dx: -12.5, tercio: 0.85,
        cajas: [[10, 10]] },
      { id: 'pecho-centrado', nombre: 'Pecho centrado', dx: 0, tercio: 1 / 4,
        cajas: [[25, 30]] },
      { id: 'delante-grande', nombre: 'Delante grande', dx: 0, tercio: 1 / 4,
        cajas: [[30, 40]] },
      { id: 'espalda', nombre: 'Espalda', dx: 0, tercio: 1 / 4, cara: 'espalda',
        cajas: [[30, 40]] },
      /* EL DORSAL no es un logo: es el nombre y el número de cada prenda, con
         alturas fijas (25 cm el número, 6 cm la letra del nombre, 3 cm de
         separación). Por eso la caja son 30×34 cm y no 30×40 como la espalda
         grande: es exactamente lo que ocupa el bloque, y así el dibujo sale a la
         escala de verdad sin tener que escalar nada a ojo. Quien lo rellena es
         dorsales.js; quien lo corta, plotter/dorsales.py. */
      { id: 'dorsal', nombre: 'Dorsal (nombre y número)', dx: 0, tercio: 1 / 4,
        cara: 'espalda', cajas: [[30, 34]], soloSiSePide: true },
      /* Editor libre de la camiseta (28/09): dos SUPERFICIES independientes,
         pecho y espalda, de 30 × 40 cada una. Van una al lado de la otra en
         la superficie total (60 × 40) para que el editor las trate como dos
         ventanas que no se solapan: lo que se pone en una nunca cae en la
         otra. Solo entran si el producto las pide (soloSiSePide). Cada una
         tiene su foto (ropa.liquid, fotosLibre) y su tramo de precio. */
      { id: 'pecho-libre', nombre: 'Pecho', cara: 'delante', libre: true, soloSiSePide: true,
        x: 100, y: 120, cajas: [[30, 40]], ventana: [0, 0] },
      { id: 'espalda-libre', nombre: 'Espalda', cara: 'espalda', libre: true, soloSiSePide: true,
        x: 100, y: 120, cajas: [[30, 40]], ventana: [30, 0] },
      /* Mangas del editor libre (21/10/2026, Xavi: «opción para personalizar las mangas, cada manga 3 €»): dos ventanas más de
         9 × 9 cm junto a pecho y espalda, cada una con su foto (recorte ampliado de la manga, ropa.liquid / camiseta-fotos.liquid)
         y su tramo de precio. Solo entran en los productos con la etiqueta `mangas`. */
      { id: 'manga-izq-libre', nombre: 'Manga izquierda', cara: 'delante', libre: true, soloSiSePide: true,
        x: 100, y: 120, cajas: [[9.5, 9.5]], ventana: [60, 0] },
      { id: 'manga-der-libre', nombre: 'Manga derecha', cara: 'delante', libre: true, soloSiSePide: true,
        x: 100, y: 120, cajas: [[9.5, 9.5]], ventana: [70, 0] },
      /* La franja de los omóplatos, centrada en la línea de axilas: es lo que
         llevaba la camiseta laboral cuando era una oferta recortada. */
      { id: 'espalda-omoplatos', nombre: 'Espalda (omóplatos)', dx: 0, tercio: 0.5,
        cara: 'espalda', cajas: [[27, 15]] },
      /* La lumbar, que se pide sobre todo en despedidas. Cuelga de una
         distancia fija por debajo de la axila, no de una proporción: son 32 cm,
         que en una M deja unos 4 cm hasta el bajo. */
      { id: 'espalda-lumbar', nombre: 'Espalda lumbar', dx: 0, bajo: 32,
        cara: 'espalda', cajas: [[25, 12]] },
      /* Las mangas se enseñan de cerca: en la prenda entera un logo de 9 cm es
         un punto y no se ve dónde cae. */
      { id: 'manga-izquierda', nombre: 'Manga izquierda', x: 143, y: 50,
        marco: [118, 24, 164, 72], cajas: [[9, 9]] },
      { id: 'manga-derecha', nombre: 'Manga derecha', x: 57, y: 50,
        marco: [36, 24, 82, 72], cajas: [[9, 9]] }
    ],
    bolsa: [{ id: 'frente', nombre: 'Frente', x: 100, y: 135, cajas: [[25, 30]] }],
    delantal: [{ id: 'pecho', nombre: 'Pecho', x: 100, y: 106, cajas: [[20, 15], [20, 30], [30, 40]] }],
    gorra: [{ id: 'frontal', nombre: 'Frontal', x: 100, y: 70, cajas: [[8, 5]] }],
    /* LA TAZA TIENE DOS CARAS Y UNA VUELTA ENTERA, que es como la vende Xavi.
     *
     * "Derecha" e "izquierda" son las dos caras a cada lado del asa, y se
     * distinguen en el dibujo por dónde queda el asa: mirando la cara derecha,
     * el asa te queda a la IZQUIERDA. Eso es lo que hace `espejo`.
     *
     * La panorámica es UNA sola pasada de plancha que da la vuelta al cuerpo,
     * así que no es lo mismo que marcar las dos caras: por eso se pisan y están
     * declaradas en PAREJAS más abajo.
     *
     * Medidas de una taza de 330 ml. Si la plancha de Xavi da otra cosa, se
     * cambian aquí y en ningún sitio más. */
    /* Los recuadros eran casi tan altos como la taza entera (8,5 cm sobre un
       cuerpo de 8,7): en la pantalla del cliente el marco tocaba la boca y la
       base sin aire. Ni Pixum ni el resto de mockups de referencia hacen eso
       — todos dejan un margen claro arriba, abajo y a los lados. Se recorta a
       8×7 (y el panorámico igual de alto, solo cambia el ancho al dar la
       vuelta) para que el recuadro se vea dentro de la taza, no pegado a ella. */
    taza: [
      /* y=126, no 122: 122 centra el recuadro contra la pared recta (86-158),
         pero a la vista el ojo mide contra la silueta ENTERA, curva de la
         base incluida (86-166); centrado contra eso cae en 126. Con 122 el
         recuadro se veía subido, con más aire abajo (por la curva de la
         base) que arriba. */
      /* libre: primera zona de prueba del editor libre (imagen + texto
         movibles, en vez de "sube un archivo"). De momento solo aquí. */
      /* La superficie real de impresión es la panorámica (20 × 9,5 cm, a
         toda altura, dato de Xavi). Cada lado es una VENTANA de 8 cm sobre
         ella: `ventana` = [x, y] en cm de la esquina superior izquierda de
         la ventana dentro de la panorámica.
         La lámina da la vuelta a la taza y sus dos extremos se juntan EN EL
         ASA: el centro de la panorámica (8–12) es la cara opuesta al asa, que
         se ve de canto en los dos lados. Con el asa a la IZQUIERDA se ve el
         principio de la lámina (0–8); con el asa a la DERECHA, el final
         (12–20). Xavi (28/09): "las vistas están al revés"; lo estaban. */
      { id: 'izquierda', nombre: 'Lado izquierdo', cara: 'izquierda', espejo: true,
        x: 100, y: 126, cajas: [[8, 9.5]], libre: true, ventana: [0, 0] },
      { id: 'derecha', nombre: 'Lado derecho', cara: 'derecha',
        x: 100, y: 126, cajas: [[8, 9.5]], libre: true, ventana: [12, 0] },
      /* x,y de esta zona son del dibujo PLANO (taza_panoramica), no del de
         frente: es otra vista, con otra caja, así que su centro cae en otro
         sitio (82,75, no 122). */
      { id: 'panoramica', nombre: 'Panorámica', cara: 'panoramica',
        x: 100, y: 82.75, cajas: [[20, 9.5]], libre: true, ventana: [0, 0] }
    ]
  };

  /* Cómo se llama cada cara cuando hay que escribirla debajo del dibujo. Sin
     esto, una taza con dos logos ponía "Delante" debajo de las dos. */
  var CARAS = {
    delante: 'Delante', espalda: 'Espalda',
    izquierda: 'Lado izquierdo', derecha: 'Lado derecho',
    panoramica: 'Panorámica'
  };
  function caraNombre(c) { return CARAS[c] || CARAS.delante; }

  /* Las zonas que admite una prenda. "permitidas" es la lista de ids del
     producto; vacía o ausente = todas. Se respeta el orden del catálogo, no el
     que venga del metafield: así el paso 3 sale siempre de arriba abajo. */
  function zonas(familia, permitidas) {
    var todas = POSICIONES[familia] || POSICIONES.ropa;
    /* "Vacío = todas" tiene una excepción: las zonas marcadas `soloSiSePide` NO
       entran en ese "todas". El dorsal es una de ellas. La mayoría de las fichas
       tienen el metafield vacío, así que sin esto aparecería en la camiseta de
       niño —donde un bloque de 34 cm no cabe— y en la laboral, y nadie lo habría
       decidido. Para ofrecerlo hay que marcarlo a mano en el producto, que es
       justo la decisión que toca tomar prenda por prenda. */
    var ok = {};
    (permitidas || []).forEach(function (id) { ok[String(id).trim()] = true; });
    if (!permitidas || !permitidas.length) {
      return todas.filter(function (p) { return !p.soloSiSePide; });
    }
    var fuera = todas.filter(function (p) { return ok[p.id]; });
    return fuera.length ? fuera
      : todas.filter(function (p) { return !p.soloSiSePide; });
  }

  /* ZONAS QUE SE PISAN. Un "delante grande" de 30×40 ocupa el sitio del pecho
     centrado y el del bolsillo, así que marcar las dos no significa nada en el
     taller — y encima se cobraría dos veces una impresión que es una sola.
     Marcar una desmarca la otra.

     Se declaran por PAREJAS y la tabla se rellena en los dos sentidos sola,
     para que no se quede coja al añadir una nueva.

     Lo que NO está aquí es a propósito:
       · pecho izquierdo ↔ pecho derecho: conviven (logo a un lado, nombre al
         otro) y es el caso más típico de empresa.
       · pecho centrado ↔ pecho izquierdo/derecho: se pisan un poco, pero
         Xavi los deja convivir.
       · espalda ↔ lumbar: la grande acaba justo donde empieza la lumbar, así
         que caben las dos en la misma prenda.
       · las mangas se llevan bien con todo. */
  var PAREJAS = [
    ['pecho-centrado', 'delante-grande'],
    ['delante-grande', 'pecho-izquierdo'],
    ['delante-grande', 'pecho-derecho'],
    ['espalda', 'espalda-omoplatos'],
    /* El dorsal ocupa la espalda entera. Marcarlo junto con un logo de espalda
       sería prometer dos impresiones en el mismo sitio; y en el taller una de
       las dos se quedaría fuera sin que nadie lo hubiera decidido. */
    ['dorsal', 'espalda'],
    ['dorsal', 'espalda-omoplatos'],
    /* La panorámica de la taza YA da la vuelta: pedirla junto con una de las
       caras sería cobrar dos veces una sola pasada de plancha. */
    ['panoramica', 'derecha'],
    ['panoramica', 'izquierda']
  ];
  var CHOCAN = {};
  PAREJAS.forEach(function (p) {
    (CHOCAN[p[0]] = CHOCAN[p[0]] || []).push(p[1]);
    (CHOCAN[p[1]] = CHOCAN[p[1]] || []).push(p[0]);
  });

  // con qué zonas choca esta; siempre una lista, aunque esté vacía
  function choca(id) { return CHOCAN[id] || []; }

  // el área máxima de una zona, en cm, para poder enseñarla sin tener archivo
  function area(pos) {
    var cajas = (pos && pos.cajas) || [];
    var w = 0, h = 0;
    cajas.forEach(function (m) { if (m) { w = Math.max(w, m[0]); h = Math.max(h, m[1]); } });
    return [w, h];
  }

  // de centímetros de prenda a unidades del dibujo
  function unidadesPorCm(p) { return (p.cuerpo[1] - p.cuerpo[0]) / p.anchoRealCm; }

  /* El centro del logo en el dibujo. altoCm es lo que mide de alto ESTA
     impresión: hace falta porque el anclaje es el borde de arriba. */
  function punto(p, pos, altoCm) {
    var k = unidadesPorCm(p);
    var x = pos.x != null ? pos.x : 100 + (pos.dx || 0) * k;
    if (pos.y != null) return [x, pos.y];
    var h = (altoCm || 0) * k;
    var axila = p.axila || 58;
    /* El borde de arriba: a tantos cm por debajo de la axila si la zona lo dice
       así (lumbar), y si no por proporción del alto de la impresión. */
    var top = pos.bajo != null
      ? axila + pos.bajo * k
      : axila - h * (pos.tercio != null ? pos.tercio : 0);
    // lo que tapa la espalda (la capucha) no se estampa: se empieza debajo
    if (pos.cara === 'espalda' && p.espaldaDesde != null && top < p.espaldaDesde) top = p.espaldaDesde;
    return [x, top + h / 2];
  }

  function prendaDe(nombre) { return PRENDAS[nombre] || PRENDAS.camiseta; }

  /* Qué dibujo usar para una cara. La panorámica no es la misma vista que el
     resto (ver taza_panoramica): si existe un "prenda_cara", es ese; si no,
     el de siempre. */
  function prendaIdDe(prenda, cara) {
    var variante = prenda + '_' + cara;
    return PRENDAS[variante] ? variante : prenda;
  }

  /* Medida a la que sale el logo: se encaja dentro del área del sitio sin
     deformarlo, igual que hace el taller. Un logo apaisado toca el ancho y uno
     alto toca el alto; en los dos casos sale lo más grande que cabe. */
  function medida(pos, px) {
    var cajas = pos.cajas || [pos.maxCm];
    var mejor = null;
    for (var i = 0; i < cajas.length; i++) {
      var m = cajas[i];
      if (!m) continue;
      var k = Math.min(m[0] / px[0], m[1] / px[1]);
      var w = px[0] * k, h = px[1] * k;
      if (!mejor || w * h > mejor[0] * mejor[1]) mejor = [w, h];
    }
    return mejor || [0, 0];
  }

  // luminancia 0..1 de un #rrggbb, para saber si la prenda es clara u oscura
  function luz(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return 1;
    var n = parseInt(h, 16);
    return (0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255;
  }

  /* ---------- LA PRENDA CON FOTO (26/09) ----------
   * Xavi, viendo los dibujos: «¿no puedes hacer algo más realista?». Así que,
   * donde hay foto, la prenda es la foto: se guardan sus sombras (gris, 200 =
   * el tono medio de la tela) con su silueta en el alfa, sin la etiqueta de la
   * marca, y se tiñe del color que elija el cliente. Las sombras oscurecen el
   * color; lo que brilla por encima del tono medio se aclara; y en los
   * colores muy oscuros se añade un poco de relieve, que si no el negro queda
   * plano. Hasta que la foto carga —o si el navegador no deja leerla— se
   * pinta el calco de siempre, así que nunca se queda en blanco. */
  var tintes = {};
  // mapa: { prenda: url } o { prenda: { delante: url, espalda: url } }
  function fotos(mapa, alCargar) {
    Object.keys(mapa || {}).forEach(function (k) {
      var p = PRENDAS[k], v = mapa[k];
      if (!p || !p.foto || !v) return;
      var urls = typeof v === 'string' ? { delante: v } : v;
      [['delante', 'fotoImg'], ['espalda', 'fotoEspaldaImg']].forEach(function (cara) {
        if (!urls[cara[0]] || p[cara[1]]) return;
        if (cara[0] === 'espalda' && !p.fotoEspalda) return;
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { p[cara[1]] = img; if (alCargar) alCargar(k); };
        img.src = urls[cara[0]];
      });
    });
  }
  function hexRgb(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    return isNaN(n) ? [233, 233, 238] : [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function tintar(img, color, pw, ph) {
    var clave = img.src + '|' + color + '|' + pw + 'x' + ph;
    if (tintes[clave]) return tintes[clave];
    var cv = document.createElement('canvas');
    cv.width = pw; cv.height = ph;
    var x = cv.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, pw, ph);
    var d = x.getImageData(0, 0, pw, ph), q = d.data;   // si la foto no deja leerse, salta aquí
    var c = hexRgb(color), oscuro = (c[0] + c[1] + c[2]) / 3 < 70;
    for (var i = 0; i < q.length; i += 4) {
      if (!q[i + 3]) continue;
      var sh = q[i] / 200;
      var som = sh < 1 ? sh : 1, luzExtra = sh > 1 ? (sh - 1) * 230 : 0;
      for (var k = 0; k < 3; k++) {
        var v = c[k] * som + luzExtra;
        if (oscuro) v += (sh - 1) * 60 + 18;
        q[i + k] = v < 0 ? 0 : v > 255 ? 255 : v;
      }
    }
    x.putImageData(d, 0, 0);
    var n = Object.keys(tintes);
    if (n.length > 24) delete tintes[n[0]];
    tintes[clave] = cv;
    return cv;
  }
  /* La foto es un JPEG en gris (pesa cinco veces menos que un PNG con alfa) y
     la silueta la pone el calco: se recorta con él. */
  function pintarFoto(c, p, color, espalda) {
    var f = espalda ? p.fotoEspalda : p.foto, img = espalda ? p.fotoEspaldaImg : p.fotoImg;
    if (!f || !img || p.fotoMala) return false;
    try {
      var t = c.getTransform ? c.getTransform() : { a: 2 };
      var esc = Math.max(1, Math.abs(t.a));
      var pw = Math.max(1, Math.round(f.w * esc)), ph = Math.max(1, Math.round(f.h * esc));
      var tinta = tintar(img, color, pw, ph);
      c.save();
      c.clip(new Path2D(f.silueta || p.silueta));
      c.drawImage(tinta, f.x, f.y, f.w, f.h);
      c.restore();
      return true;
    } catch (e) { p.fotoMala = true; return false; }
  }

  function dibujarPrenda(c, p, colorPrenda, espalda) {
    // sin color de producto (o con uno solo, como la bolsa crema): el de la prenda
    var porDefecto = p.colorPorDefecto || '#e9e9ee';
    if (!p.fondoImpresion && pintarFoto(c, p, colorPrenda || porDefecto, espalda)) {
      var extra = espalda ? p.lineasFotoEspalda : p.lineasFoto;
      if (extra && extra.length) {
        c.save();
        c.lineWidth = 0.9; c.lineCap = 'round';
        c.strokeStyle = luz(colorPrenda || porDefecto) < 0.45 ? 'rgba(255,255,255,.16)' : 'rgba(0,0,0,.14)';
        extra.forEach(function (d) { c.stroke(new Path2D(d)); });
        c.restore();
      }
      return;
    }
    c.save();
    c.lineJoin = 'round'; c.lineCap = 'round';
    var ruta = new Path2D(p.silueta);
    var elegido = colorPrenda || porDefecto;
    /* En la taza el cuerpo es blanco siempre y el color va en el asa y en el
       interior. En una prenda, el cuerpo ES el color. */
    var fondo = p.fondoImpresion || elegido;
    /* Sobre un cuerpo oscuro el contorno negro no se ve y la prenda parece una
       mancha. Ahí se dibuja en claro. */
    var oscura = luz(fondo) < 0.45;
    var fuerte = oscura ? 'rgba(255,255,255,.55)' : 'rgba(0,0,0,.38)';
    var flojo = oscura ? 'rgba(255,255,255,.38)' : 'rgba(0,0,0,.26)';
    c.fillStyle = fondo;
    c.strokeStyle = fuerte;
    c.lineWidth = 2.4;
    c.fill(ruta); c.stroke(ruta);
    // las piezas que SÍ llevan el color elegido (boca y asa de la taza)
    (p.color || []).forEach(function (d) {
      var r = new Path2D(d);
      c.fillStyle = elegido;
      c.lineWidth = 1.6; c.strokeStyle = fuerte;
      c.fill(r); c.stroke(r);
    });
    c.lineWidth = 1.6;
    c.strokeStyle = flojo;
    var trazos = espalda ? (p.lineasEspalda || []) : (p.lineas || []);
    trazos.forEach(function (d) { c.stroke(new Path2D(d)); });
    if (!espalda) (p.puntos || []).forEach(function (q) {
      c.beginPath(); c.arc(q[0], q[1], q[2], 0, Math.PI * 2); c.stroke();
    });
    c.restore();
  }

  /* Encuadre: la prenda ocupa la tarjeta entera, no una caja de 200×240 con la
     mitad de aire. Con aire alrededor, un logo de pecho de 9,9 cm se veía
     ridículo aunque la escala fuera exacta. */
  var MARGEN = 5;
  function encuadre(prenda, pos) {
    var k = (pos && pos.marco) || prendaDe(prenda).caja || [0, 0, 200, 240];
    return { x: k[0] - MARGEN, y: k[1] - MARGEN,
             w: k[2] - k[0] + MARGEN * 2, h: k[3] - k[1] + MARGEN * 2 };
  }
  // alto en píxeles que le toca a un dibujo de esa anchura
  function alto(prenda, ancho, pos) {
    var e = encuadre(prenda, pos);
    return (ancho || 200) * e.h / e.w;
  }

  /* Deja el lienzo listo y con la prenda ya pintada: tamaño, escala y encuadre.
     Lo usan los dos dibujos, el de una zona y el de varias. */
  function preparar(lienzo, prenda, marco, ancho, color, espalda, espejo) {
    var p = prendaDe(prenda);
    var e = encuadre(prenda, marco);
    var altoPx = ancho * e.h / e.w;
    var esc = ancho / e.w;
    var dpr = window.devicePixelRatio || 1;
    lienzo.style.width = Math.round(ancho) + 'px';
    lienzo.style.height = Math.round(altoPx) + 'px';
    lienzo.width = Math.round(ancho * dpr);
    lienzo.height = Math.round(altoPx * dpr);
    var c = lienzo.getContext('2d');
    c.setTransform(dpr * esc, 0, 0, dpr * esc, -e.x * dpr * esc, -e.y * dpr * esc);
    c.clearRect(e.x, e.y, e.w, e.h);
    /* Reflejo horizontal SOLO de la prenda, nunca del logo: un logo impreso en
       la cara derecha se lee igual de derecho. Se refleja respecto al centro
       del encuadre, así la prenda no se va de cuadro. */
    if (espejo) { c.save(); c.translate(2 * (e.x + e.w / 2), 0); c.scale(-1, 1); }
    dibujarPrenda(c, p, color, espalda);
    if (espejo) c.restore();
    return c;
  }

  /* LA PRENDA UNA VEZ, CON TODOS LOS LOGOS DE ESA CARA.
   *
   * Un dibujo por zona hacía pensar que eran camisetas distintas: el cliente
   * que pedía pecho y espalda veía dos prendas y contaba dos. Son dos
   * impresiones sobre la misma.
   *
   * "lista" son las zonas de UNA cara; "arte" y "px" van en paralelo. Devuelve
   * la medida de cada una, en el mismo orden, para poder escribirlas debajo.
   */
  function varias(lienzo, prenda, lista, opciones) {
    var o = opciones || {};
    var prendaId = prendaIdDe(prenda, (lista[0] && lista[0].cara) || '');
    var p = prendaDe(prendaId);
    var espalda = !!(lista[0] && lista[0].cara === 'espalda');
    // siempre la prenda entera: con dos zonas no hay un zoom que valga para las dos
    var c = preparar(lienzo, prendaId, null, o.ancho || 200, o.color, espalda,
      !!(lista[0] && lista[0].espejo));
    var k = unidadesPorCm(p);
    return lista.map(function (pos, i) {
      var arte = Array.isArray(o.arte) ? o.arte[i] : o.arte;
      var px = (Array.isArray(o.px) && Array.isArray(o.px[0])) ? o.px[i] : o.px;
      if (!pos || !arte || !px) return null;
      var cm = medida(pos, px);
      var w = cm[0] * k, h = cm[1] * k;
      var q = punto(p, pos, cm[1]);
      c.drawImage(arte, q[0] - w / 2, q[1] - h / 2, w, h);
      return cm;
    });
  }

  /* Dibuja la prenda con el logo puesto en una posición.
     opciones: { ancho, color, arte (canvas), px, sinMarco } */
  function dibujar(lienzo, prenda, pos, opciones) {
    var o = opciones || {};
    var prendaId = prendaIdDe(prenda, (pos && pos.cara) || '');
    var p = prendaDe(prendaId);
    var espalda = !!(pos && pos.cara === 'espalda');
    var c = preparar(lienzo, prendaId, o.sinMarco ? null : pos,
      o.ancho || 200, o.color, espalda, !!(pos && pos.espejo));

    if (!pos) return null;
    // de centímetros a unidades del dibujo: el ancho del cuerpo de la prenda
    // en el dibujo equivale a sus centímetros reales de pecho
    var k = unidadesPorCm(p);

    /* Sin archivo todavía: se enseña el ÁREA en la que se va a imprimir, un
       recuadro a trazos con su medida máxima. Es lo que el cliente necesita
       para elegir zona antes de subir nada. */
    if (o.area || !o.arte || !o.px) {
      if (!o.area) return null;
      var cmA = area(pos);
      var wA = cmA[0] * k, hA = cmA[1] * k;
      var qA = punto(p, pos, cmA[1]);
      c.save();
      c.setLineDash([5, 4]);
      c.lineWidth = 1.8;
      c.strokeStyle = luz(o.color || '#e9e9ee') < 0.45
        ? 'rgba(255,255,255,.85)' : 'rgba(0,0,0,.55)';
      c.strokeRect(qA[0] - wA / 2, qA[1] - hA / 2, wA, hA);
      c.restore();
      return { cm: cmA, espalda: espalda, area: true };
    }

    var cm = medida(pos, o.px);
    var w = cm[0] * k, h = cm[1] * k;
    var q = punto(p, pos, cm[1]);
    c.drawImage(o.arte, q[0] - w / 2, q[1] - h / 2, w, h);
    return { cm: cm, espalda: espalda };
  }

  // recorta un texto al ancho disponible, con puntos suspensivos
  function cortar(x, texto, max) {
    var s = String(texto || '');
    if (x.measureText(s).width <= max) return s;
    while (s.length > 1 && x.measureText(s + '…').width > max) s = s.slice(0, -1);
    return s + '…';
  }

  /* El mockup que viaja DENTRO del pedido.
   *
   * Una tira con la prenda repetida, una por sitio donde va el logo, con su
   * nombre y su medida debajo. No es una foto: es exactamente lo que el
   * cliente ha visto antes de pagar, guardado con el pedido para que nadie
   * tenga que mandar un correo de prueba preguntando "¿así te vale?".
   *
   * Cada zona puede llevar SU archivo: "arte" y "px" admiten un array paralelo
   * a "posiciones". Es lo normal en un pedido de empresa —logo pequeño al
   * pecho y diseño grande a la espalda— y el mockup tiene que enseñarlo tal
   * cual, porque es la prueba que se guarda con el pedido.
   *
   * o: { color, arte, px, pies: [[medida, archivo] por posición], titulo }
   */
  function mockup(prenda, posiciones, o) {
    o = o || {};
    var lista = posiciones && posiciones.length ? posiciones : [null];
    var arteDe = function (i) { return Array.isArray(o.arte) ? o.arte[i] : o.arte; };
    var pxDe = function (i) {
      return (Array.isArray(o.px) && Array.isArray(o.px[0])) ? o.px[i] : o.px;
    };

    /* UNA PRENDA POR CARA, no una por zona. Antes salía un dibujo por cada
       sitio y parecían camisetas distintas: el que pedía pecho y espalda veía
       dos prendas y contaba dos. Son dos impresiones sobre la misma. */
    var caras = [];
    lista.forEach(function (p, i) {
      /* La cara es la que diga la zona, no solo delante o espalda: una taza
         tiene lado izquierdo, lado derecho y panorámica, y cada una es un
         dibujo aparte. Meterlas todas en "delante" apilaba los logos uno
         encima de otro en la misma taza. */
      var cara = (p && p.cara) || 'delante';
      var g = caras.filter(function (x) { return x.cara === cara; })[0];
      if (!g) { g = { cara: cara, zonas: [], arte: [], px: [], pies: [] }; caras.push(g); }
      g.zonas.push(p);
      g.arte.push(arteDe(i));
      g.px.push(pxDe(i));
      /* El pie de cada impresión son DOS líneas: zona con su medida, y debajo
         el archivo. En una sola se cortaba el nombre del fichero justo cuando
         es el dato que hace falta en taller para emparejar arte y sitio.
         o.pies[i] = [medida, nombre del archivo]. */
      var pieZ = (o.pies && o.pies[i]) || [];
      g.pies.push((p ? p.nombre + ' · ' : '') + (pieZ[0] || ''));
      if (pieZ[1]) g.pies.push(pieZ[1]);
    });

    var esc = o.escala || 1.7;
    var aU = Math.round(200 * esc);
    /* La panorámica es un dibujo distinto (la taza desarrollada, sin asa) y
       más bajo que el de frente: si se forzaba a la misma altura salía
       estirada. Cada cara mide la suya y todas cuelgan de la más alta. */
    caras.forEach(function (g) {
      g.hU = Math.round(alto(prendaIdDe(prenda, g.cara), aU));
    });
    var hU = caras.reduce(function (n, g) { return Math.max(n, g.hU); }, 0);
    // el pie crece con la cara que más impresiones lleve
    var filas = caras.reduce(function (n, g) { return Math.max(n, g.pies.length); }, 1);
    var cab = 46, pie = 32 + filas * 24;
    var c = document.createElement('canvas');
    c.width = aU * caras.length;
    c.height = cab + hU + pie;
    var x = c.getContext('2d');
    var tipo = '-apple-system, system-ui, Segoe UI, Roboto, sans-serif';

    x.fillStyle = '#ffffff'; x.fillRect(0, 0, c.width, c.height);
    if (o.titulo) {
      x.fillStyle = '#121212';
      x.font = 'bold 22px ' + tipo;
      x.textAlign = 'left';
      x.fillText(o.titulo, 18, 31);
    }
    caras.forEach(function (g, i) {
      var lienzo = document.createElement('canvas');
      varias(lienzo, prenda, g.zonas, { ancho: aU, color: o.color, arte: g.arte, px: g.px });
      // centrada verticalmente en la fila cuando su cara es más baja que la más alta
      x.drawImage(lienzo, i * aU, cab + (hU - g.hU) / 2, aU, g.hU);
      var cx = i * aU + aU / 2;
      x.textAlign = 'center';
      x.fillStyle = '#121212';
      x.font = 'bold 19px ' + tipo;
      x.fillText(caraNombre(g.cara), cx, cab + hU + 25);
      /* Una línea por impresión, con su zona, su medida y su archivo. Se
         recortan al ancho del panel: con dos prendas al lado, un nombre largo
         se metía en el panel vecino y no se leía ninguno de los dos. */
      x.fillStyle = '#5a5a5a';
      x.font = '17px ' + tipo;
      g.pies.forEach(function (linea, j) {
        x.fillText(cortar(x, linea, aU - 16), cx, cab + hU + 49 + j * 24);
      });
    });
    x.textAlign = 'left';
    return c;
  }

  window.Colocacion = {
    PRENDAS: PRENDAS, POSICIONES: POSICIONES, fotos: fotos,
    prendaDe: prendaDe, medida: medida, dibujar: dibujar, luz: luz,
    mockup: mockup, alto: alto, punto: punto, zonas: zonas, area: area,
    MODELOS: MODELOS, tallasDe: tallasDe, choca: choca, varias: varias,
    caraNombre: caraNombre,
    // el editor libre (editor-libre.js) los necesita para saber, en px de
    // pantalla, dónde cae exactamente el recuadro de una zona sobre el
    // lienzo ya dibujado — la misma cuenta que hace dibujar() por dentro.
    encuadre: encuadre, unidadesPorCm: unidadesPorCm, prendaIdDe: prendaIdDe
  };
})();